import React from "react";
import { Link, useLocation } from "react-router-dom";
import getBreadCrumb from "../../utils/BreadcrumbMap";
import "../../assets/styles/pages/style.css";
import currentPageStore from "../../utils/stores/currentPageStore";
import SanitizeHref from "../../utils/SanitizeHref";

function Breadcrumbs() {
  const currentPage = currentPageStore((state) => state.currentPage);
  const location = useLocation();
  let currentLink = "";

  // 1. Split the path into raw strings
  const pathnames = location.pathname.split("/").filter((x) => x);

  return (
    <nav aria-label="Breadcrumb" className="full-breadcrumb">
       
      <ol className="breadcrumbs layout-crumb" style={{ listStyle: 'none', display: 'flex', padding: 0 }}>
        {/* Home is always the first static li */}
        <li>
          <Link to="/">Home</Link>
          <span aria-hidden="true" className="separator"> &gt; </span>
        </li>

        {pathnames.map((value, index) => {
          const isLast = index === pathnames.length - 1;
          currentLink += `/${value}`;
          const label = isLast ? currentPage : getBreadCrumb(value);

          return (
            <li key={currentLink}>
              {isLast ? (
                /* 2. Current page uses aria-current for KY state compliance */
                <span aria-current="page" className="current-page">
                  {label}
                </span>
              ) : (
                <>
                  <Link to={SanitizeHref(currentLink)}>{label}</Link>
                  <span aria-hidden="true" className="separator"> &gt; </span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

export default Breadcrumbs;
